import React from 'react';
import { useLocation } from 'react-router-dom';
import { node } from 'prop-types';
import ErrorBoundary from './index';

/**
 * The boundary, keyed on the current path.
 *
 * A class component cannot read the router, and the boundary needs to know
 * when the user has navigated so a crash on one screen does not follow them
 * to the next. This is the whole of that: read the location, hand it over.
 */
const RouteErrorBoundary = ({ children }) => {
  const location = useLocation();
  return <ErrorBoundary resetKey={location.pathname}>{children}</ErrorBoundary>;
};

RouteErrorBoundary.propTypes = {
  children: node.isRequired,
};

export default RouteErrorBoundary;
